import React from 'react';
import ViewDocument from '../components/ViewDocument';

export default function ViewProformaInvoice() {
  return (
    <ViewDocument
      apiPath="proforma-invoices"
      numberField="pi_number"
      editPath="/edit-proforma-invoice"
      listPath="/proforma-invoices"
      docLabel="Proforma Invoice"
    />
  );
}
